import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import bgimage from '../../../../images/default_staff.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditCustomer = ({ show, onClose, customerData, id, onUpdated }) => {
  const [companyName, setCompanyName] = useState('');
  const [companyNumber, setCompanyNumber] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [gstinNumber, setGstinNumber] = useState('');
  const [address, setAddress] = useState('');
  const [pincode, setPincode] = useState('');
  const [bankName, setBankName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [checkedBankInfo, setCheckedBankInfo] = useState(true);
  const [file, setFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});  // <-- for validation errors
  const imageInputRef = useRef(null);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const ImgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
  const [previewUrl, setPreviewUrl] = useState('');

    useEffect(() => {
      if (customerData) {
        setCompanyName(customerData.company_name || '');
        setCompanyNumber(customerData.company_number || '');
        setCustomerEmail(customerData.customer_email || '');
        setCustomerName(customerData.customer_name || '');
        setCustomerNumber(customerData.customer_number || '');
        setGstinNumber(customerData.gstin_number || '');
        setAddress(customerData.address || '');
        setPincode(customerData.pincode || '');
        setBankName(customerData.bank_name || '');
        setBranchName(customerData.branch_name || '');
        setAccountHolderName(customerData.account_holder_name || '');
        setAccountNumber(customerData.account_number || '');
        setIfscCode(customerData.ifsc_code || '');
        setCheckedBankInfo(true);
        setFile(customerData.image ? `${ImgBaseUrl}/${customerData.image}` : '');
        if (customerData.image) {
        setPreviewUrl(`${ImgBaseUrl}/${customerData.image}`);
        setFile(null); // clear file, since this is an existing image URL
      } else {
        setPreviewUrl('');
        setFile(null);
      }
      if (imageInputRef.current) {
        imageInputRef.current.value = '';
      }
      setFormErrors({});
    }
    }, [customerData]);

  const fileHandler = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
          setFile(selectedFile);
          setPreviewUrl(URL.createObjectURL(selectedFile));
      }
  };

  const removeImage = () => {
    setFile(null);
    setPreviewUrl('');
    if (imageInputRef.current) {
        imageInputRef.current.value = '';
    }
  };

  const handleCheckboxChange = () => {
    setCheckedBankInfo(prev => !prev);
  };

  const validateForm = () => {
    const errors = {};

    const companyNameVal = (companyName || '').toString();
    const companyNumberVal = (companyNumber || '').toString();
    const customerEmailVal = (customerEmail || '').toString();
    const customerNameVal = (customerName || '').toString();
    const customerNumberVal = (customerNumber || '').toString();
    const gstinNumberVal = (gstinNumber || '').toString();
    const addressVal = (address || '').toString();
    const pincodeVal = (pincode || '').toString();
    const bankNameVal = (bankName || '').toString();
    const branchNameVal = (branchName || '').toString();
    const accountHolderNameVal = (accountHolderName || '').toString();
    const accountNumberVal = (accountNumber || '').toString();
    const ifscCodeVal = (ifscCode || '').toString();

    if (!companyNameVal.trim()) errors.companyName = 'Company Name is required';
    
    if (!companyNumberVal.trim()) errors.companyNumber = 'Company Mobile No is required';
    else if (!/^\d{10}$/.test(companyNumberVal.trim())) errors.companyNumber = 'Enter a valid 10-digit number';

    if (!customerEmailVal.trim()) errors.customerEmail = 'Email ID is required';
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(customerEmailVal.trim())) errors.customerEmail = 'Enter a valid email address';

    if (!customerNameVal.trim()) errors.customerName = 'Contact Person Name is required';

    if (!customerNumberVal.trim()) errors.customerNumber = 'Contact Person Mobile No is required';
    else if (!/^\d{10}$/.test(customerNumberVal.trim())) errors.customerNumber = 'Enter a valid 10-digit number';

    if (gstinNumberVal.trim()) {
      // Validate GSTIN format only if not empty
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstinRegex.test(gstinNumberVal.trim())) {
        errors.gstinNumber = 'Enter valid GSTIN';
      }
    }

    if (!addressVal.trim()) errors.address = 'Address is required';

    if (!pincodeVal.trim()) errors.pincode = 'Pin Code is required';
    else if (!/^\d{6}$/.test(pincodeVal.trim())) errors.pincode = 'Enter a valid 6-digit Pin Code';

    if (checkedBankInfo) {
      if (!bankNameVal.trim()) errors.bankName = 'Bank Name is required';
      if (!branchNameVal.trim()) errors.branchName = 'Branch Name is required';
      if (!accountHolderNameVal.trim()) errors.accountHolderName = 'Account Holder Name is required';
      if (!accountNumberVal.trim()) errors.accountNumber = 'Account Number is required';
      if (!ifscCodeVal.trim()) {
        errors.ifscCode = 'IFSC Code is required';
      } else {
        const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        if (!ifscRegex.test(ifscCodeVal.trim().toUpperCase())) {
          errors.ifscCode = 'Enter valid IFSC Code';
        }
      }

    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleUpdate = async () => {
        if (!validateForm()) return;

        const formData = new FormData();

        formData.append('company_name', companyName);
        formData.append('company_number', companyNumber);
        formData.append('customer_email', customerEmail);
        formData.append('customer_name', customerName);
        formData.append('customer_number', customerNumber);
        formData.append('gstin_number', gstinNumber);
        formData.append('address', address);
        formData.append('pincode', pincode);

        formData.append('bankInfoEnabled', checkedBankInfo); 

        if (checkedBankInfo) {
            formData.append('bank_name', bankName);
            formData.append('branch_name', branchName);
            formData.append('account_holder_name', accountHolderName);
            formData.append('account_number', accountNumber);
            formData.append('ifsc_code', ifscCode);
        }

        if (file) {
            formData.append('image', file);
        }

        try {
            const response = await fetch(`${BaseUrl}/manage_corporate_customer/update_customer/${id}`, {
            method: 'POST',
            body: formData,
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
            throw new Error(result.message || 'Failed to update customer');
            }

            toast.success('Customer updated successfully!');
            onClose();
            onUpdated?.();
        } catch (error) {
            toast.error('Error updating customer: ' + error.message);
        }
  };

  const ErrorMessage = ({ error }) => (
    error ? <small className="text-danger">{error}</small> : null
  );

  const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <Modal show={show} onHide={onClose} size="xl">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Customer</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className='text-white'>×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Company Name<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.companyName ? 'is-invalid' : ''}`}
                placeholder='Enter Company Name'
                value={companyName}
                onChange={e => setCompanyName(capitalizeWords(e.target.value))}
              />
              <ErrorMessage error={formErrors.companyName} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Company Mobile No<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.companyNumber ? 'is-invalid' : ''}`}
                placeholder='Enter Company Mobile No'
                value={companyNumber}
                onChange={e => {
                  const val = e.target.value;
                  // Allow only digits and max 10 characters
                  if (/^\d{0,10}$/.test(val)) {
                    setCompanyNumber(val);
                  }
                }}
                maxLength={10}
              />
              <ErrorMessage error={formErrors.companyNumber} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Email ID<span className="required">*</span>
              </label>
              <input
                type="email"
                className={`form-control ${formErrors.customerEmail ? 'is-invalid' : ''}`}
                placeholder='Enter Email ID'
                value={customerEmail}
                onChange={e => setCustomerEmail(e.target.value)}
              />
              <ErrorMessage error={formErrors.customerEmail} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Contact Person Name<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.customerName ? 'is-invalid' : ''}`}
                placeholder='Enter Contact Person Name'
                value={customerName}
                onChange={e => setCustomerName(capitalizeWords(e.target.value))}
              />
              <ErrorMessage error={formErrors.customerName} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Contact Person Mobile No<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.customerNumber ? 'is-invalid' : ''}`}
                placeholder='Enter Contact Person Mobile No'
                value={customerNumber}
                maxLength={10}
                onChange={e => {
                  const val = e.target.value;
                  // Allow only digits and max 10 characters
                  if (/^\d{0,10}$/.test(val)) {
                    setCustomerNumber(val);
                  }
                }}
              />

              <ErrorMessage error={formErrors.customerNumber} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                GSTIN
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.gstinNumber ? 'is-invalid' : ''}`}
                placeholder='Enter GSTIN'
                value={gstinNumber}
                onChange={e => setGstinNumber(e.target.value)}
              />
              <ErrorMessage error={formErrors.gstinNumber} />
            </div>

            <div className='col-lg-4 mb-2'>
              <label className="text-black font-w500 fs-7">
                Address <span className="required">*</span>
              </label>
              <textarea
                rows={1}
                className={`form-control ${formErrors.address ? 'is-invalid' : ''}`}
                placeholder="Address"
                value={address}
                onChange={e => setAddress(capitalizeWords(e.target.value))}
              />
              <ErrorMessage error={formErrors.address} />
            </div>

            <div className="col-lg-4 mb-2">
              <label className="text-black font-w500 fs-7">
                Pin Code<span className="required">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${formErrors.pincode ? 'is-invalid' : ''}`}
                placeholder='Enter Pin Code'
                value={pincode}
                onChange={e => setPincode(e.target.value)}
              />
              <ErrorMessage error={formErrors.pincode} />
            </div>

            {/* <div className='col-lg-4'>
              <label className="text-black font-w500 fs-7 d-block">Image</label>
              <span className='fs-8 text-gray-800'>Size: </span>
              <span className='fs-8 text-danger'>15 * 15</span>
              <span className='fs-8 text-gray-800 ms-2'>Format: </span>
              <span className='fs-8 text-danger'>.png, .jpg</span>
              <div className="avatar-upload d-flex align-items-center">
                <div className="change position-relative">
                  <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                    <img
                    id="saveImageFile"
                    src={previewUrl || bgimage}
                    alt={file ? file.name : 'Default Avatar'}
                    className="p-1 h-125px w-125px"
                    />

                  </div>
                  <div className="change-btn">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      style={{ display: 'none' }}
                      onChange={fileHandler}
                      ref={imageInputRef}
                    />
                    <div className="mt-2 d-flex justify-content-center gap-3">
                      <Button
                        className="btn-xs mb-2"
                        variant="success"
                        onClick={() => imageInputRef.current.click()}
                      >
                        <i className="fa fa-upload color-success fs-5" />
                      </Button>
                      <Button
                        className="btn-xs mb-2"
                        variant="danger"
                        onClick={removeImage}
                      >
                        <i className="fa fa-close color-danger fs-5" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className="form-check custom-checkbox mt-3">
            <input
              type="checkbox"
              onChange={handleCheckboxChange}
              className="form-check-input me-3"
              id="customCheckBox1"
              checked={checkedBankInfo}
            />
            <label className="text-red fs-4 font-w600 mb-3" htmlFor="customCheckBox1">Bank Information</label>
          </div>
          {checkedBankInfo && (
            <div className='row'>
              <div className="col-lg-4 mb-2">
                <label className="text-black font-w500 fs-7">
                  Bank Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.bankName ? 'is-invalid' : ''}`}
                  placeholder='Enter Bank Name'
                  value={bankName}
                  onChange={e => setBankName(capitalizeWords(e.target.value))}
                />
                <ErrorMessage error={formErrors.bankName} />
              </div>

              <div className="col-lg-4 mb-2">
                <label className="text-black font-w500 fs-7">
                  Branch Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.branchName ? 'is-invalid' : ''}`}
                  placeholder='Enter Branch Name'
                  value={branchName}
                  onChange={e => setBranchName(capitalizeWords(e.target.value))}
                />
                <ErrorMessage error={formErrors.branchName} />
              </div>

              <div className="col-lg-4 mb-2">
                <label className="text-black font-w500 fs-7">
                  Account Holder Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.accountHolderName ? 'is-invalid' : ''}`}
                  placeholder='Enter Account Holder Name'
                  value={accountHolderName}
                  onChange={e => setAccountHolderName(capitalizeWords(e.target.value))}
                />
                <ErrorMessage error={formErrors.accountHolderName} />
              </div>

              <div className="col-lg-4 mb-2">
                <label className="text-black font-w500 fs-7">
                  Account Number<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.accountNumber ? 'is-invalid' : ''}`}
                  placeholder='Enter Account Number'
                  value={accountNumber}
                  onChange={e => setAccountNumber(e.target.value)}
                />
                <ErrorMessage error={formErrors.accountNumber} />
              </div>

              <div className="col-lg-4 mb-2">
                <label className="text-black font-w500 fs-7">
                  IFSC Code<span className="required">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.ifscCode ? 'is-invalid' : ''}`}
                  placeholder='Enter IFSC Code'
                  value={ifscCode}
                  onChange={e => setIfscCode(e.target.value)}
                />
                <ErrorMessage error={formErrors.ifscCode} />
              </div>
            </div>
          )}

          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <Button
              className="btn btn-sm btn-primary"
              onClick={handleUpdate}
            >
              Update Customer
              <i className="fas fa-angle-double-right ms-2"></i>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};


export default EditCustomer;

